<template>
  <Modal width="800"  v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">添加维修单</div>
    <Form :model="formData" :label-width="108"  :rules="formRules" ref="formData">
      <div>
        <h3>物业地址</h3>
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="项目名称：" prop="projectId"  >
              <Select :label-in-value="true" v-model="formData.projectId" class="item-width" @on-change="changeProject">
                  <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="区域类型：" prop="areaType" >
              <Select v-model="formData.areaType" class="item-width" @on-change="changeAreaType">
                <Option v-for="item in areaTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="12" v-if="formData.areaType===1" key="room">
            <FormItem label="房间号：" prop="roomId"  >
              <Select
              class="item-width"
              v-model="formData.roomId"
              filterable
              remote
              :remote-method="remoteMethod"
              :loading="remoteLoading"
              placeholder="请输入想查询的房间号"
              :label-in-value="true"
              @on-change="getRoomCode"
              >
                <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12" v-if="formData.areaType===2" key="fnArea">
            <FormItem label="功能区：" prop="roomId" >
              <Select  :label-in-value="true" v  key="roomId" v-model="formData.roomId" class="item-width" @on-change="getAreaName">
                <Option value="">{{(formData.projectId==='' ? '请先选择项目': (fnAreaList.length === 0?'暂无数据':'请选择'))}}</Option>
                <Option v-for="item in fnAreaList" :value="item.value" :key="item.value">{{ item.text }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </div>
      <div>
        <h3>维修内容</h3>
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="大类：" prop="categoryCode"  >
              <Select :label-in-value="true" v-model="formData.categoryCode" class="item-width" @on-change="changeCategoryCode">
                <Option value="">请选择</Option>
                <Option v-for="item in categoryList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="物品名称：" prop="goodsCode" >
              <Select v-model="formData.goodsCode" :label-in-value="true" @on-change="getGoodsName" class="item-width" >
                <Option value="">{{formData.categoryCode==='' ? '请先选择大类': (goodsList.length===0?'暂无数据':'请选择') }}</Option>
                <Option v-for="item in goodsList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="故障标签：" prop="failureId"  >
              <Select :label-in-value="true" v-model="formData.failureId" @on-change="getFailureName"  class="item-width">
                <Option value="">{{formData.goodsCode==='' ? '请先选择物品': (failureList.length===0?'暂无数据':'请选择') }}</Option>
                <Option v-for="item in failureList" :value="item.tagCode" :key="item.tagCode">{{ item.tagName }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="空间：" prop="spaceId" >
              <Select v-model="formData.spaceId" :label-in-value="true" @on-change="getSpaceName"   class="item-width">
                <Option v-for="item in spaceList" :value="item.value" :key="item.value">{{ item.text }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">

        <Col span="12">
          <FormItem label="预约上门时间：" prop="visitTimeFlag" >
            <DatePicker ref="formData.visitTimeFlag" type="date" :options="visitTimeFlag()" v-model="formData.visitTimeFlag" @on-change="changevisitTimeFlag" class="item-width"></DatePicker>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="报修时段：" prop="visitTime"  >
            <Select v-model="formData.visitTime" class="item-width">
              <Option value="">{{formData.failureId==='' ? '请先选择故障标签': (visitTimeList.length===0?'暂无数据':'请选择') }}</Option>
              <Option v-for="item in visitTimeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="是否返修：" prop="isReworking"  >
            <Select v-model="formData.isReworking" class="item-width">
                <Option v-for="item in isReworkingList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
          </FormItem>
        </Col>

      </Row>
      <FormItem label="故障描述：" prop="failureDesc"  >
         <Input style="width:624px" v-model="formData.failureDesc" type="textarea" :autosize="{minRows: 2}" :maxlength="150" placeholder="最多输入150字"></Input>
      </FormItem>
      </div>
      <div>
        <h3>联系人信息</h3>
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="联系人：" prop="visitLinkman">
              <Input v-model="formData.visitLinkman" class="item-width" ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="联系方式：" prop="visitMobile">
              <Input v-model="formData.visitMobile" class="item-width" ></Input>
            </FormItem>
          </Col>
        </Row>
        <!-- <Row :gutter="16">
          <Col span="12">
          <FormItem label="报修人：" prop="repairsMan">
              <Input v-model="formData.repairsMan" class="item-width" ></Input>
            </FormItem>
          </Col>
        </Row> -->
      </div>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="save" :loading="loading">保存</Button>
    </div>
  </Modal>
</template>

<script type="text/ecmascript-6">
import { getProjects } from 'api/common'
import { getSelectedData} from 'api/archives.js'
import { order, getFailureTags,getCondition,getAppointmentTime } from 'api/repaire'
import { getFnByProject,fuzzyRoom } from 'api/functionalArea'
import moment from 'moment'
export default {
  name:name,
  created(){
    getSelectedData().then( res => {
      this.projectList = res.data.projects
      this.formData.projectId =  this.projectList[0].value
      this.areaTypeList = res.data.configArea
    })
  },
  props:{
    contractCode:{
      type:String,
      default:''
    },
    n:{
      type:Number,
      default:0
    },
    spaceList:{
      type:Array,
      default: ()=>{
        return []
      }
    },

  },
  watch: {
    n(){
      this.show = true
      this.$refs['formData'].resetFields();
      this.formData.projectId = this.projectList[0].value
      this.formData.areaType = 1
      this.formData.isReworking = 0
    }
  },
  components: {

  },
  data() {
    const validateDate = (rules,value,callback)=>{
      rules.type = typeof value === 'object' ? 'object':'string'
      if(!value){
        callback(new Error('请选择上门时间'));
      }
      callback();
    }
    const validateArea = (rules,value,callback)=>{

      if(!value){
        if(this.formData.areaType===1){
          callback(new Error('请选择房间'));
        }else {
          callback(new Error('请选择功能区'));
        }
      }
      callback();
    }
    const validatePhone = (rules,value,callback)=>{
      let pattern = /^1\d{10}$/

      if(pattern.test(value)){
        callback();
      }else{
        callback(new Error('输入正确的手机号'));
      }

    }
    return {
      remoteLoading:false,
      loading:false,
      show:false,

      projectList:[],
      areaTypeList:[],
      roomList:[],
      fnAreaList:[],
      categoryList:[],
      goodsList:[],
      failureList:[],
      appointmentTimeList:[],
      // 是否返修，写死
      isReworkingList:[
        {
          text:'是',
          value:1
        },
        {
          text:'否',
          value:0
        }
      ],

      formData:{
        projectId:'',
        projectName:'',
        areaType:'',
        // rentContractCode:'',
        // areaCode:'',
        // areaName:'',
        categoryCode:'',
        categoryName:'',
        goodsCode:'',
        goodsName:'',
        failureId:'',
        failureName:'',
        // emergencyDegree:'',
        isReworking:0,
        visitTime:'',
        visitTimeFlag:'',
        failureDesc:'',
        visitLinkman:'',
        visitMobile:'',
        // repairsMan:'',
        roomId:'',
        roomCode:'',
        spaceName:'',
        spaceId:''
      },
      formRules:{
        projectId:[ {required: true, type:'string', message:'请选择所属项目', trigger:'change'} ],
        areaType:[ {required: true, type:'number', message:'请选择区域类型', trigger:'change'} ],
        roomId:[ {required: true, type:'string',validator: validateArea,trigger:'change'} ],
        // areaCode:[ {required: true, type:'string', message:'请选择功能区', trigger:'change'} ],
        categoryCode:[ {required: true, type:'string', message:'请选择大类', trigger:'change'} ],
        goodsCode:[ {required: true, type:'string', message:'请选择物品', trigger:'change'} ],
        failureId:[ {required: true, type:'string', message:'请选择故障标签', trigger:'change'} ],
        spaceId:[ {required: true, type:'string', message:'请选择空间', trigger:'change'} ],
        visitTime:[ {required: true, type:'string', message:'请选择报修时段',  trigger:'change'} ],
        visitTimeFlag:[ {required: true, validator: validateDate, trigger:'change'} ],
        visitLinkman:[ {required: true, type:'string', message:'请输入联系人', trigger:'blur'} ],
        visitMobile:[ {required: true,validator: validatePhone, trigger:'blur'} ],
        // repairsMan:[ {required: true, type:'string', message:'请输入报修人', trigger:'blur'} ],
      }
    }
  },
  computed:{
    appointmentDateList(){
      return this.appointmentTimeList.map(o => o.date);
    },
    visitTimeList() {
      if (!this.formData.failureId) {
        return [];
      }
      const index = this.appointmentDateList.indexOf(this.formData.visitTimeFlag);
      const time = this.appointmentTimeList[index] && this.appointmentTimeList[index].time || [];
      return time.map(o => {
        return {value: o, text: o}
      });
    }
  },
  methods:{
    changeProject(obj) {
      let value = obj.value
      this.formData.roomId = ''
      // this.formData.areaCode = ''
      if(value !== ''){
          this.formData.projectName = obj.label
          this.getFunctionalArea(value)
          this.getCategoryAndGoods(value);
      }else{
        this.formData.projectName = ''
        this.fnAreaList = []
        // this.formData.configArea = ''
      }
    },
    changeAreaType(){
      this.formData.roomId = ''
      // this.formData.areaCode = ''

    },
    changeCategoryCode(obj){
      if(!obj.value){
        this.goodsList = []
        this.failureList = []
      } else{
        this.formData.categoryName = obj.label
        for (let [index, item] of this.categoryList.entries()) {
        if (obj.value === item.value) {
            this.goodsList = this.categoryList[index].children;
        }
      }
      }
    },
    changevisitTimeFlag(val){
      this.formData.visitTimeFlag = val
    },
    handleCancel(){
      this.show = false
    },
    getAreaName(area){
      if(area.value){
        this.formData.roomCode = area.label
      } else {
        this.formData.roomCode = ''
      }
    },
    getFailureName(failure){
      if(failure.value){
        this.formData.failureName = failure.label
        getAppointmentTime({
          goodsCode: this.formData.goodsCode,
          projectFid: this.formData.projectId,
          tagCodeList: this.formData.failureId
        }).then(res => {
          this.appointmentTimeList = res.data || []
        })
      } else {
        this.formData.failureName = ''
      }

    },
    getGoodsName(goods){
      if(goods.value){
        this.formData.goodsName = goods.label
          getFailureTags({goodsCode: goods.value, projectFid: this.formData.projectId}).then(res => {
          this.failureList = res.data.faultFlagList || []
        })
      } else {
        this.formData.goodsName = ''
        this.failureList = []
      }
    },
    getFunctionalArea(projectId){
      if(projectId !== ''){
        getFnByProject({projectid:projectId}).then( res => {
          if(res.data.length === 0) {
            this.fnAreaList = []
          } else{
            this.fnAreaList = res.data
          }
        })
      }
    },
    getCategoryAndGoods(projectId){
        if(projectId === ''){
            return
        }
        getCondition({projectFid: projectId}).then(res => {
            if (!res.data.category || !res.data.category) {
                this.categoryList = []
            } else {
                this.categoryList = res.data.category
            }
        })
    },
    getRoomCode(room){
      if(room.value){
        this.formData.roomCode = room.label
      } else {
        this.formData.roomCode = ''
      }
    },
    getSpaceName(space){
      if(space.value){
        this.formData.spaceName = space.label
      } else {
        this.formData.spaceName = ''
      }
    },
    remoteMethod(query){
      if (query !== '' && this.formData.projectId !=='') {
        this.remoteLoading = true;
        let params = {
          projectid:this.formData.projectId,
          roomnumber:query
        }
        fuzzyRoom(params).then( res => {
          this.remoteLoading = false;
          this.roomList = res.data;
        })
      } else {
          this.roomList = [];
          this.formData.roomId = ''
      }
    },
    save(){

      this.$refs['formData'].validate( bool => {
        if(bool){
          if(!this.formData.projectName){
            this.formData.projectName = this.projectList.find( item => {
              return item.value === this.formData.projectId
            }).text
          }
          // console.log(this.formData)

          this.loading = true
          order(this.formData).then( res => {
            this.$Message.success('创建成功！')
            this.$emit('refresh')
            this.show = false
          }).finally( ()=>{
            this.loading = false
          })

        }

      })

    },
    visitTimeFlag() {
      const _this = this;
      return {
        disabledDate(date) {
          if(!_this.formData.failureId){
            return true;
          }
          return !_this.appointmentDateList.includes(moment(date).format('YYYY-MM-DD'));
        }
      }
    },

  }
}
</script>

<style scoped>
.item-width{
  width: 240px;
}
h3 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
}
</style>
